export const renderVersion = (cenope) => {
  if (cenope && cenope.idubic) {
    return "Full";
  } else {
    return "Lite";
  }
};
